let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iFcso")).then(() => parcelRequire('9NHjX'));